export default __webpack_public_path__ + "static/media/myproduct.7da88bd0.svg";